import {
  getAllChairmanMeetingRequests,
  getChairmanMeetingRequestById,
  acceptChairmanMeetingRequest,
  rejectChairmanMeetingRequest,
  markChairmanMeetingCreated,
} from "../controllers/chairmanMeetingRequestController";

export const handleGetAllChairmanMeetingRequests = async (options = {}) => {
  return await getAllChairmanMeetingRequests(options); // { meetings, count }
};

export const handleGetChairmanMeetingRequestById = async (meetingRequestId) => {
  return await getChairmanMeetingRequestById(meetingRequestId);
};

export const handleAcceptChairmanMeetingRequest = async ({
  meetingRequestId,
  approvedByUid,
  expectedMeetingDate,
  location,
}) => {
  await acceptChairmanMeetingRequest({
    meetingRequestId,
    approvedByUid,
    expectedMeetingDate,
    location,
  });
  return { message: "Chairman Meeting Request Accepted Successfully" };
};

export const handleRejectChairmanMeetingRequest = async ({
  meetingRequestId,
  rejectedByUid,
  rejectedReason,
}) => {
  await rejectChairmanMeetingRequest({
    meetingRequestId,
    rejectedByUid,
    rejectedReason,
  });
  return { message: "Chairman Meeting Request Rejected Successfully" };
};

export const handleMarkChairmanMeetingCreated = async ({
  meetingRequestId,
  personUserUid,
  personName,
}) => {
  await markChairmanMeetingCreated({ meetingRequestId, personUserUid, personName });
  return { message: "Meeting marked as created successfully." };
};
